import React from "react";
import PropTypes from "prop-types";
import { Paper, Stack, Typography, Box } from "@mui/material";
import { InfoOutlined as InfoIcon } from "@mui/icons-material";
import { colors, customShadows, borderRadius, borderRadiusPx } from "../../../../theme";
import { CommonButton } from "../../ui";

/**
 * DashboardNoticeBanner - Contextual notification & regulatory banner with high-contrast action button.
 */
const DashboardNoticeBanner = ({
  icon = <InfoIcon sx={{ color: colors.dashboard.noticeBanner.icon, fontSize: "1.25rem" }} />,
  message = "",
  actionText = "",
  onActionClick,
  actionIcon,
  sx = {},
}) => {
  const nb = colors.dashboard.noticeBanner;

  if (!message) {
    return null;
  }

  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 2, sm: 2.25 },
        borderRadius: borderRadiusPx.banner,
        border: `1px solid ${nb.border}`,
        background: nb.background,
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: { xs: "flex-start", sm: "center" },
        justifyContent: "space-between",
        gap: 2,
        ...sx,
      }}
    >
      <Stack direction="row" spacing={1.5} alignItems="center" sx={{ flex: 1 }}>
        <Box sx={{ flexShrink: 0, display: "flex", alignItems: "center" }}>
          {icon}
        </Box>
        <Typography
          variant="body2"
          sx={{
            color: nb.text,
            fontWeight: 500,
            fontSize: "0.875rem",
            lineHeight: 1.5,
          }}
        >
          {message}
        </Typography>
      </Stack>

      {actionText && (
        <CommonButton
          variant="contained"
          size="medium"
          startIcon={actionIcon}
          onClick={onActionClick}
          sx={{
            flexShrink: 0,
            backgroundColor: nb.buttonBg,
            color: nb.buttonText,
            borderRadius: borderRadiusPx.lg,
            px: 2.5,
            py: 0.9,
            "&:hover": {
              backgroundColor: nb.buttonHover,
              boxShadow: customShadows.buttonPrimaryHover,
            },
          }}
        >
          {actionText}
        </CommonButton>
      )}
    </Paper>
  );
};

DashboardNoticeBanner.propTypes = {
  icon: PropTypes.node,
  message: PropTypes.node.isRequired,
  actionText: PropTypes.string,
  onActionClick: PropTypes.func,
  actionIcon: PropTypes.node,
  sx: PropTypes.object,
};

export default DashboardNoticeBanner;
